import { getPreviousYear, momentToTimestampSeconds, getStartOfPreviousYear } from "../../utils/date.js";
import "react-intl";
const transactionHistoricalMinYear = 2021;
const transactionHistoricalMaxYear = getPreviousYear() - 1;
const nonHistoryTransactionTimestampMin = momentToTimestampSeconds(getStartOfPreviousYear());
const TransactionTypeTypeName = "TransactionType";
const TransactionStatusWithReasonTypeName = "TransactionStatusWithReason";
const TransactionStatusTypeName = "TransactionStatus";
const TransactionFilterTypeTypeName = "TransactionFilterType";
const TransactionViewModelKeysTypeName = "TransactionViewModelKeys";
const TransactionQueryFieldsTypeName = "TransactionQueryFields";
const TransactionColumnSettingsKeysTypeName = "TransactionColumnSettingsKeys";
const ReasonCodeTypeName = "ReasonCode";
export {
  ReasonCodeTypeName,
  TransactionColumnSettingsKeysTypeName,
  TransactionFilterTypeTypeName,
  TransactionQueryFieldsTypeName,
  TransactionStatusTypeName,
  TransactionStatusWithReasonTypeName,
  TransactionTypeTypeName,
  TransactionViewModelKeysTypeName,
  nonHistoryTransactionTimestampMin,
  transactionHistoricalMaxYear,
  transactionHistoricalMinYear
};
//# sourceMappingURL=constants.js.map
